export function currencyFormat(value: any){
  const amount = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
  }).format(value/100);
  return `${amount}`;
}